export default __webpack_public_path__ + "static/media/chatsSelected.d0e5f862.svg";